// React imports
import React from 'react';

// gatsby imports
import { PageProps, graphql } from 'gatsby';

// SEO
import SEO from 'components/seo';

// Theme and layout
import WithTheme from 'components/WithTheme';
import Layout from 'views/Layout';
import Commissions from 'views/Commissions';

type DataProps = {
    site: {
        buildTime: string;
    };
};

const ComisionesPage: React.FC<PageProps<DataProps>> = ({ data, path, location }) => (
    <WithTheme>
        <Layout location={location}>
            <SEO title="Comisiones" />

            <Commissions />
        </Layout>
    </WithTheme>
);

export default ComisionesPage;

export const query = graphql`
    {
        site {
            buildTime(formatString: "YYYY-MM-DD hh:mm a z")
        }
    }
`;
